module.exports = __webpack_public_path__ + "img/6.3efd0bbe.png";